import React, { useEffect, useState } from "react";
import { TopBar } from "@/components/TopBar";
import { BottomNav } from "@/components/BottomNav";
import { PostCard } from "@/components/PostCard";
import { EmptyState } from "@/components/EmptyState";
import { useI18n } from "@/i18n";
import { useRouter } from "@/router/Router";
import { useBackButton } from "@/lib/hooks";
import { fetchPosts } from "@/lib/api";
import type { PostSummary } from "@/types";

const TABS = ["news", "article", "promo"] as const;

export function PostsPage({ type }: { type?: (typeof TABS)[number] }) {
  const { t, locale } = useI18n();
  const { navigate, goBack } = useRouter();
  const [posts, setPosts] = useState<PostSummary[] | null>(null);

  useBackButton(goBack);

  useEffect(() => {
    setPosts(null);
    fetchPosts({ type, limit: 50 })
      .then(setPosts)
      .catch(() => setPosts([]));
  }, [type, locale]);

  return (
    <>
      <TopBar title={t("posts.title")} onBack={goBack} />
      <main className="page">
        <div className="segmented" style={{ marginBottom: "var(--space-4)" }}>
          <button className="chip" data-active={!type} onClick={() => navigate({ name: "posts" })}>
            {t("catalog.all")}
          </button>
          {TABS.map((tab) => (
            <button key={tab} className="chip" data-active={type === tab} onClick={() => navigate({ name: "posts", type: tab })}>
              {t(`posts.tabs.${tab}`)}
            </button>
          ))}
        </div>
        {posts === null ? (
          <p style={{ color: "var(--color-muted)" }}>{t("common.loading")}</p>
        ) : posts.length === 0 ? (
          <EmptyState art="generic" title={t("posts.empty")} />
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {posts.map((p) => (
              <PostCard key={p.id} post={p} />
            ))}
          </div>
        )}
      </main>
      <BottomNav />
    </>
  );
}
